import React from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

/** Shared hover surface for labels, explanations and navigation. */
export default function FableTooltip({ title, slotProps, ...props }: TooltipProps) {
  return <Tooltip
    enterDelay={500}
    describeChild
    {...props}
    // MUI adds a native title for string descriptions while closed. Render the
    // content as a node so only our tooltip appears, including on long hovers.
    title={typeof title === "string" && title ? <span>{title}</span> : title}
    slotProps={{
      ...slotProps,
      tooltip: ownerState => {
        const tooltip = typeof slotProps?.tooltip === "function" ? slotProps.tooltip(ownerState) : slotProps?.tooltip;
        const sx = tooltip?.sx;
        return {
          ...tooltip,
          sx: [{
            bgcolor: "#101219",
            color: "rgba(255,255,255,0.94)",
            border: "1px solid #333333",
            borderRadius: "12px",
            p: 1,
            width: "max-content",
            maxWidth: "min(250px, calc(100vw - 32px))",
            boxShadow: "0 10px 30px rgba(0,0,0,0.42)",
            fontSize: 14,
            fontWeight: 600,
            lineHeight: 1.45,
            overflowWrap: "break-word",
          }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])],
        };
      },
    }}
  />;
}
